export default __webpack_public_path__ + "static/media/AaronBio.f674a3fa.jpg";